import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IPayerInformation } from '../../interfaces/send-payment/send-payment.interface';
import { AbstractSendPaymentService } from '../abstraction/abstract.send-payment.service';

@Injectable({
  providedIn: 'root',
})
export class SendPaymentService extends AbstractSendPaymentService {
  controller = `/manager/institution`;
  urlGetPayerInformation = `${environment.apiUrl}${this.controller}/getPayerInformation`;

  constructor(private http: HttpClient) {
    super();
  }

  getPayerInformation(primaryRTN: string): Promise<IPayerInformation | undefined> {
    return this.http
      .get<IPayerInformation>(`${this.urlGetPayerInformation}/${primaryRTN}`)
      .toPromise();
  }
}
